// Korean (ko)
export default {
  // --- Shell / nav ---
  app_name: '물때 타이드',
  search_stations: '관측소 검색',
  search_stations_hint: '관측소 검색 (⌘K)',
  settings: '설정',
  app_store: 'App Store에서 다운로드',
  google_play: 'Google Play에서 다운로드',
  app_promo_title: '무료 앱을 다운로드하세요. 더 빠릅니다 🙂',
  app_promo_body: '같은 조석·조류 예측을 휴대폰에서.',
  privacy: '개인정보 처리방침',
  terms: '이용약관',
  data_sources: '데이터 출처',
  support: '지원',

  guides: '가이드',
  // --- Home ---
  home_title: '근처 조수와 해류 찾기',
  by_country: '국가별',
  favorite_tides: '즐겨찾는 조수',
  recent_tides: '최근 조수',
  nearby_tides: '근처 조수',
  favorite_currents: '즐겨찾는 해류',
  recent_currents: '최근 해류',
  nearby_currents: '근처 해류',
  favorite_charts: '즐겨찾는 해도',
  recent_charts: '최근 해도',
  nearby_charts: '근처 해도',
  finding_stations: '근처 관측소를 찾는 중…',
  distance_away: '{{distance}} 거리',

  // --- Search overlay ---
  search_placeholder: '관측소 검색…',
  tide_stations: '조수 관측소',
  current_stations: '해류 관측소',
  recents: '최근',
  search_unavailable: '지금은 검색을 사용할 수 없습니다.',
  no_stations_found: '관측소를 찾을 수 없습니다.',
  search_prompt: '조수·해류 관측소를 이름으로 검색하세요.',

  // --- Settings ---
  appearance: '화면 모드',
  appearance_system: '시스템',
  appearance_light: '라이트',
  appearance_dark: '다크',
  tide_height: '조위',
  unit_feet: '피트',
  unit_meters: '미터',
  distance: '거리',
  unit_miles: '마일',
  unit_kilometers: '킬로미터',
  recent_stations: '최근 관측소',
  clear_recents: '최근 항목 삭제',
  currents: '해류',
  nautical_charts: '해도',
  browse_by_country: '국가별로 보기',
  countries_auto: '자동',
  countries_always: '항상 표시',
  countries_never: '표시 안 함',
  show: '표시',
  hide: '숨김',

  // --- Station pages (tide + current) ---
  tide_title: '{{name}} 조수',
  current_title: '{{name}} 해류',
  last_tide: '지난 조수',
  next_tide: '다음 조수',
  coefficient: 'Coef',
  last_current: '지난 해류',
  next_current: '다음 해류',
  following_current: '이어지는 해류',
  high: '높음',
  low: '낮음',
  tides: '조수',
  sun: '해',
  moon: '달',
  sunrise_now: '일출',
  sunset_now: '일몰',
  moonrise_now: '월출',
  moonset_now: '월몰',
  sunrise_week: '일출',
  sunset_week: '일몰',
  moonrise_week: '월출',
  moonset_week: '월몰',
  add_to_favorites: '즐겨찾기에 추가',
  remove_from_favorites: '즐겨찾기에서 삭제',

  // --- Week table dates ---
  today: '오늘',
  tomorrow: '내일',

  // --- Moon phases ---
  phase_new_moon: '삭',
  phase_waxing_crescent: '초승달',
  phase_first_quarter: '상현달',
  phase_waxing_gibbous: '상현망간의 달',
  phase_full_moon: '보름달',
  phase_waning_gibbous: '하현망간의 달',
  phase_last_quarter: '하현달',
  phase_waning_crescent: '그믐달',

  // --- Tide / current status vocabulary ---
  rising: '상승 중',
  falling: '하강 중',
  high_tide: '만조',
  low_tide: '간조',
  ebb: '썰물',
  flood: '밀물',
  slack: '정조',

  // --- Relative time ---
  just_now: '방금',
  somethings_wrong: '오류가 발생했습니다',
  hour_ago: '{{hour}}시간 전',
  hours_ago: '{{hour}}시간 전',
  minute_ago: '{{minute}}분 전',
  minutes_ago: '{{minute}}분 전',
  hour_minute_ago: '{{hour}}시간 {{minute}}분 전',
  hour_minutes_ago: '{{hour}}시간 {{minute}}분 전',
  hours_minute_ago: '{{hour}}시간 {{minute}}분 전',
  hours_minutes_ago: '{{hour}}시간 {{minute}}분 전',
  hour_from_now: '앞으로 {{hour}}시간 후',
  hours_from_now: '앞으로 {{hour}}시간 후',
  minute_from_now: '앞으로 {{minute}}분 후',
  minutes_from_now: '앞으로 {{minute}}분 후',
  hour_minute_from_now: '앞으로 {{hour}}시간 {{minute}}분 후',
  hour_minutes_from_now: '앞으로 {{hour}}시간 {{minute}}분 후',
  hours_minute_from_now: '앞으로 {{hour}}시간 {{minute}}분 후',
  hours_minutes_from_now: '앞으로 {{hour}}시간 {{minute}}분 후',

  // --- Insights ---
  insights_7_day_overview: '7일 인사이트',
  no_insights_available: '이 관측소에 대한 인사이트가 없습니다.',
  insights_current_extremes: '조류 극값',
  insights_fastest_flood: '가장 빠른 창조',
  insights_fastest_ebb: '가장 빠른 낙조',
  insights_strongest_daily_currents: '일별 최대 조류',
  insights_fastest_current: '가장 빠름',
  insights_slowest_current: '가장 느림',
  insights_tidal_extremes: '조석 극값',
  insights_highest_tide: '최고 조위',
  insights_lowest_tide: '최저 조위',
  insights_strongest_daily_movements: '최대 조차 범위',
  insights_largest_tide: '최대',
  insights_smallest_tide: '최소',
  insights_value_at_time: '{{time}}에 {{value}}',
  insights_tidal_range_label: '조차',
  insights_max_current_label: '최대 조류',

  // --- Insight bands ---
  band_smaller_than_usual: '평소보다 작음',
  band_typical: '보통',
  band_larger_than_usual: '평소보다 큼',
  band_unusually_large: '비정상적으로 큼',
  band_lower_than_usual: '평소보다 낮음',
  band_unusually_low: '이례적으로 낮음',
  band_slower_than_usual: '평소보다 느림',
  band_faster_than_usual: '평소보다 빠름',
  band_unusually_fast: '비정상적으로 빠름',
  band_smaller_than_usual_height: '평소보다 낮음',
  band_larger_than_usual_height: '평소보다 높음',
  band_unusually_large_height: '비정상적으로 높음',

  // --- Map attribution ---
  attribution: '저작자 표시',
  attribution_osm: '지도 데이터 © OpenStreetMap 기여자',
  attribution_tiles: '지도 타일 제공 OpenFreeMap',
  attribution_style: '지도 스타일 © OpenMapTiles',
  ok: '확인',

  // --- Explore map ---
  current_speed: '조류 속도',
  depth: '수심',
  speed: '속도',
  depth_datum: '기준면:',
  depth_drying: '간출',
  depth_loading: '수심 데이터를 불러오는 중…',
  depth_datum_tag: '{{datum}} 기준 수심({{unit}})',
  depth_not_for_navigation: '항해용이 아닙니다.',
  depth_unavailable: '수심 데이터를 현재 사용할 수 없습니다.',
  depth_unit_m: 'm',
  depth_unit_ft: 'ft',
  go_mode_start: 'GO',
  go_mode_start_label: 'Go 모드 시작',
  go_mode_exit: 'Go 모드 종료',
  go_mode_location_denied: 'Go 모드에는 위치 정보가 필요합니다. 자물쇠 아이콘에서 활성화하세요.',
  go_mode_location_denied_ok: '확인',
  radar: '레이더',
  radar_precipitation: '강수',
  radar_light: '약함',
  radar_moderate: '보통',
  radar_heavy: '강함',
  radar_storm: '매우 강함',
  radar_forecast: '예보',
  radar_none_for_time: '해당 시각의 레이더 없음',
  now: '지금',
  explore_prompt_denied:
    '이 사이트에서는 위치 정보가 꺼져 있습니다. 주소창의 자물쇠 아이콘에서 활성화하세요.',
  open_full_map: '전체 지도 열기',
  close_full_map: '전체 지도 닫기',
  explore_full_map: '전체 지도 탐색',
  center_on_location: '내 위치로 이동',
  show_my_location: '내 위치 표시',
  map_knots_label: '{{speed}} kt',

  // --- Location pages ---
  states: '주',
  no_stations_found_location: '관측소를 찾을 수 없습니다.',
  tides_and_currents_by_country: '국가별 조수·해류',

  // --- SEO titles / descriptions ---
  settings_seo_description: '조위와 거리 단위를 선택하세요.',
  tide_seo_description: '{{name}}{{location}}의 조수 예보, 만조·간조 시각.',
  current_seo_description: '{{name}}{{location}}의 조류 예보, 밀물·썰물 시각.',
  location_title: '{{name}} 조수·해류',
  country_seo_description:
    '{{name}}의 조수 시각과 조류 예보. {{name}} 전역의 {{stateTerm}}와(과) 해안 조수 관측소를 둘러보세요.',
  state_seo_description:
    '{{country}} {{name}}의 조수·해류 예보. {{name}} 해안 관측소의 만조·간조 시각.',
  city_seo_description: '{{place}}의 조수 시각과 조류 예보. {{name}} 근처의 만조·간조와 해류.',
  // --- Chart pages (chart titles, numbers and purposes stay in the
  // issuing authority's language: they name a specific printed sheet) ---
  charts_for_station: '{{name}} 해도',
  chart_intro:
    '{{title}} 무료 해도. 측량 수심, 부표, 입표, 암초, 침선, 마리나, 정박지, 조석 관측소를 제공합니다.',
  chart_page_name: '{{title}} 해도',
  chart_seo_description:
    '{{title}} 무료 해도. 측량 수심, 부표, 입표, 암초, 침선, 마리나, 정박지, 조석 관측소를 제공합니다.',

  countries_seo_title: '국가별 조수·해류 관측소',
  countries_seo_description:
    '국가별로 조수·해류 관측소를 둘러보세요. 전 세계 해안 지역의 만조·간조 시각과 조류 예보.',
  home_seo_description:
    '근처 해안 관측소의 조수 시각과 조류 예보를 확인하세요. 현재 위치의 만조·간조를 보거나 국가별로 관측소를 둘러보세요.',
  explore_play: '재생',
  explore_pause: '일시정지',
  explore_playback_speed: '재생 속도',
  explore_time: '시각',
  skip_to_content: '본문으로 건너뛰기',
  // --- Weather (station pages) ---
  weather: '해상 날씨',
  wind: '바람',
  gusts: '돌풍',
  seas: '파도',
  time: '시각',
  air_temp: '기온',
  water_temp: '수온',
  water_temperature: '수온',
  humidity: '습도',
  pressure: '기압',
  precip_chance: '강수 확률',
  chances: '확률',
  precip_rate: '강수 강도',
  visibility: '시정',
  condition_thunderstorms: '뇌우',
  condition_freezing_rain: '어는 비',
  condition_sleet: '진눈깨비',
  condition_snow: '눈',
  condition_fog: '안개',
  condition_rain: '비',
  condition_cloudy: '흐림',
  condition_partly_cloudy: '구름 조금',
  condition_clear: '맑음',
  weather_thunder: '천둥',
  note_seas_computed_from_wind: '파고는 바람과 해안선으로 추정한 값입니다.',
  note_seas_from_nearby_open_water: '파도 정보는 인근 외해 데이터를 사용합니다.',
  note_seas_open_water_nearby:
    '인근 외해의 파도는 약 {{height}}입니다. 이곳은 더 잔잔할 수 있습니다.',
  note_seas_open_water_distant:
    '{{distance}} 떨어진 외해의 파도는 약 {{height}}입니다. 이곳은 더 잔잔할 수 있습니다.',
  note_seas_open_water_distant_dir:
    '{{direction}} 방향으로 {{distance}} 떨어진 외해의 파도는 약 {{height}}입니다. 이곳은 더 잔잔할 수 있습니다.',
  note_seas_unavailable: '이 지점의 신뢰할 수 있는 파도 정보가 없습니다.',
  note_sheltered_water_sees_less: '내만 등 보호된 수역은 보통 외해 값보다 잔잔합니다.',
  note_no_warning_feed_coverage: '이 지점을 다루는 공식 해상 경보 서비스가 없습니다.',
  note_nearest_point_across_land: '가장 가까운 예보 지점이 육지 건너편에 있습니다.',
  warnings_none_active: '발효 중인 해상 경보 없음',
  warnings_unavailable: '이 위치에서는 해상 경보를 제공하지 않습니다',
  warning_show_text: '공식 문안 보기',
  warning_hide_text: '공식 문안 숨기기',
  weather_updated: '{{time}} 업데이트',
  current_conditions: '현재 상태',
  daily_forecast: '일별 예보',
  expand_for_hourly: '펼쳐서 시간별 보기',
  hourly: '시간별',
  hourly_forecast: '시간별 예보',
  wind_speed: '풍속',
  wind_gusts: '바람 및 돌풍',
  pressure_humidity: '기압 및 습도',
  max_seas: '최대 파고',
  visibility_excellent: '매우 좋음',
  visibility_good: '좋음',
  visibility_moderate: '보통',
  visibility_poor: '나쁨',
  forecaster_text_link: '{{issuer}} 예보문',
  temperature: '온도',
  unit_fahrenheit: '화씨 (°F)',
  unit_celsius: '섭씨 (°C)',
  // --- Conditions summary (station pages) ---
  // Sea state: WMO Sea State Code. Wind: Beaufort. Both are published
  // scales with standard terminology in each language, not our own wording.
  // Warning-window and low–high range punctuation. CJK marks a range (and
  // an open end) with ～, not an en dash or a trailing plus.
  warning_window_range: '{{start}}～{{end}}',
  warning_window_open: '{{start}}～',
  range_separator_short: '～',
  // Wave-period fragments. The connector is the locale's own word for the
  // "at" in "0.5 m S @ 3s" (CJK says "period" instead); the value carries
  // the locale's seconds notation (秒/초 — bare Latin "s" reads as an
  // untranslated fragment in CJK weather products).
  seas_period_at: '주기',
  wave_period_short: '{{period}}초',
  // 16-point compass, per this locale’s meteorological convention — the
  // letters differ across languages (Z/O/Ø/V…) and CJK writes the words out.
  compass_N: '북',
  compass_NNE: '북북동',
  compass_NE: '북동',
  compass_ENE: '동북동',
  compass_E: '동',
  compass_ESE: '동남동',
  compass_SE: '남동',
  compass_SSE: '남남동',
  compass_S: '남',
  compass_SSW: '남남서',
  compass_SW: '남서',
  compass_WSW: '서남서',
  compass_W: '서',
  compass_WNW: '서북서',
  compass_NW: '북서',
  compass_NNW: '북북서',
  // Known warning types, one badge label each. Bureau-home locales use the
  // bureau’s official terminology. Unknown types fall back to the humanized
  // English code in every locale (see warningTypeLabel).
  warning_type_small_craft_advisory: '소형 선박 주의보',
  warning_type_gale_warning: '강풍 경보',
  warning_type_gale_watch: '강풍 예비특보',
  warning_type_storm_warning: '폭풍 경보',
  warning_type_storm_watch: '폭풍 예비특보',
  warning_type_hurricane_force_wind_warning: '허리케인급 바람 경보',
  warning_type_hurricane_force_wind_watch: '허리케인급 바람 예비특보',
  warning_type_special_marine_warning: '특별 해상 경보',
  warning_type_marine_weather_statement: '해상 기상 정보',
  warning_type_hazardous_seas_warning: '위험 파랑 경보',
  warning_type_brisk_wind_advisory: '약간 강한 바람 주의보',
  warning_type_low_water_advisory: '저조위 주의보',
  warning_type_dense_fog_advisory: '짙은 안개 주의보',
  warning_type_heavy_freezing_spray_warning: '심한 착빙성 물보라 경보',
  warning_type_strong_wind_warning: '강풍 경보',
  warning_type_gale_force_wind_warning: '강풍 경보',
  warning_type_storm_force_wind_warning: '폭풍 경보',
  warning_type_wind_warning: '바람 경보',
  warning_type_dense_fog_warning: '짙은 안개 경보',
  warning_type_icing_warning: '착빙 경보',
  warning_type_typhoon_warning: '태풍 경보',
  warning_type_wind_wave_warning: '풍랑 경보',
  warning_type_wind_wave_advisory: '풍랑 주의보',
  warning_type_strong_wind_advisory: '강풍 주의보',
  warning_type_storm_surge_warning: '폭풍해일 경보',
  warning_type_storm_surge_advisory: '폭풍해일 주의보',
  warning_type_thunderstorm_warning: '뇌우 경보',
  warning_type_rough_sea_warning: '높은 파도 경보',
  warning_type_fog_warning: '안개 경보',
  sea_state_calm_rippled: '잔물결',
  sea_state_smooth: '잔잔한 바다',
  sea_state_slight: '약간 높은 물결',
  sea_state_moderate: '보통 물결',
  sea_state_rough: '거친 바다',
  sea_state_very_rough: '매우 거친 바다',
  sea_state_high: '높은 물결',
  sea_state_very_high: '매우 높은 물결',
  sea_state_phenomenal: '이상 물결',
  hazard_showers: '소나기',
  hazard_reduced_visibility: '시정 불량',
  hazard_haze: '연무',
  hazard_waterspout: '용오름',
  hazard_freezing_spray: '착빙성 물보라',
  hazard_ice: '결빙',
  marine_summary_sea_wind: '{{sea}}, {{direction}}풍 {{speed}}.',
  marine_summary_wind_only_gusting: '{{direction}}풍 {{speed}}, 순간최대 {{gust}}.',
  marine_summary_sea_wind_gusting: '{{sea}}, {{direction}}풍 {{speed}}, 순간최대 {{gust}}.',
  marine_summary_wind_only: '{{direction}}풍 {{speed}}.',
  marine_summary_sea_only: '{{sea}}.',
  marine_prediction_caveat_tide_one:
    '조석 예측은 천문조만 반영하므로, 해당 경보의 기상 상황에 따라 실제 수위가 높아지거나 낮아질 수 있습니다.',
  marine_prediction_caveat_tide_many:
    '조석 예측은 천문조만 반영하므로, 위 경보들의 기상 상황에 따라 실제 수위가 높아지거나 낮아질 수 있습니다.',
  marine_prediction_caveat_current_one:
    '조류 예측은 천문조만 반영하므로, 해당 경보의 기상 상황에 따라 실제 유속이 강해지거나 약해질 수 있습니다.',
  marine_prediction_caveat_current_many:
    '조류 예측은 천문조만 반영하므로, 위 경보들의 기상 상황에 따라 실제 유속이 강해지거나 약해질 수 있습니다.',
  marine_warning_active: '이 해역에 해상 특보가 발효 중입니다.',
  marine_warnings_active: '이 해역에 해상 특보가 발효 중입니다.',
  marine_warning_upcoming: '이 해역에 {{time}}부터 해상 특보가 발효됩니다.',
  marine_warnings_upcoming: '이 해역에 {{time}}부터 해상 특보가 발효됩니다.',
  marine_summary_hazard_now: '현재 {{hazard}}.',
  marine_summary_hazard_later: '예보: {{hazard}}.',
  marine_tide_rising: '조위 {{height}}, 밀물: 다음 만조 {{time}}, {{next}}.',
  marine_tide_falling: '조위 {{height}}, 썰물: 다음 간조 {{time}}, {{next}}.',
  marine_current_flood: '다음 창조류 {{time}}, {{speed}}.',
  marine_current_ebb: '다음 낙조류 {{time}}, {{speed}}.',
  marine_current_slack: '다음 정조 {{time}}.',
  marine_current_now_flood: '창조류 {{speed}}.',
  marine_current_now_ebb: '낙조류 {{speed}}.',
  marine_current_now_slack: '정조.',
  marine_current_peak: '최강 {{time}}, {{speed}}.',

  // --- Chart furniture (navaid / hazard / POI click popups) ---
  // See en.js for the rules these follow. "IALA A" / "IALA B" stay untranslated
  // in every language: it is the standard's name.
  furn_light: '등화',
  furn_buoy: '부표',
  furn_beacon: '입표',
  furn_wreck: '침선',
  furn_rock: '암초',
  furn_obstruction: '장애물',
  furn_anchorage: '묘박지',
  furn_tss: '통항분리방식',
  furn_routing: '항로 지정',
  furn_title_buoy: '{{category}} 부표',
  furn_title_beacon: '{{category}} 입표',
  furn_cat_port: '좌현',
  furn_cat_starboard: '우현',
  furn_cat_preferred_channel_port: '우선항로 좌현',
  furn_cat_preferred_channel_starboard: '우선항로 우현',
  furn_cat_safe_water: '안전수역',
  furn_cat_isolated_danger: '고립장해',
  furn_cat_north: '북방위',
  furn_cat_east: '동방위',
  furn_cat_south: '남방위',
  furn_cat_west: '서방위',
  furn_cat_special: '특수',
  furn_cat_mooring: '계류',
  furn_cat_lateral: '측면',
  furn_characteristic: '등질',
  furn_range: '광달거리',
  furn_height: '높이',
  furn_colour: '색',
  furn_shape: '형상',
  furn_lights_on_mark: '이 표지의 등화',
  furn_topmark: '두표',
  furn_class: '분류',
  furn_least_depth_over: '최천 수심',
  furn_depth_over: '상부 수심',
  furn_state: '상태',
  furn_type: '종류',
  furn_range_value: '{{value}} M',
  furn_metres_value: '{{value}} m',
  furn_cable: '해저 케이블',
  furn_pipeline: '해저 파이프라인',
  furn_restricted_area: '제한 구역',
  furn_restriction: '제한',
  furn_mpa: '해양보호구역',
  furn_protection: '보호 수준',
  furn_agency: '관리 기관',
  furn_mpa_note: '보전을 위한 지정이며 항행 제한이 아닙니다.',
  furn_sector: '섹터',
  furn_sector_value: '{{from}}° → {{to}}°',
  lightw_f: '{{colour}} 부동광.',
  lightw_fl: '{{period}}초마다 {{colour}} 섬광.',
  lightw_fl_group: '{{period}}초마다 {{colour}} 군섬광({{count}}회).',
  lightw_lfl: '{{period}}초마다 긴 {{colour}} 섬광.',
  lightw_q: '빠른 {{colour}} 급섬광.',
  lightw_iso: '{{period}}초 주기로 명암이 같은 {{colour}} 등명암광.',
  lightw_oc: '{{period}}초마다 잠깐 어두워지는 {{colour}} 명암광.',
  lightcolour_white: '백색',
  lightcolour_red: '홍색',
  lightcolour_green: '녹색',
  lightcolour_yellow: '황색',
  furn_feet_charted_value: '{{feet}} ft (해도 수치 {{metres}} m)',
  furn_light_yes: '있음',
  furn_shown_neutral: '{{colours}} (중립색으로 표시)',
  furn_note_light: '야간에 등화가 보이는 방식입니다. 항해자는 이것으로 식별합니다.',
  furn_note_lateral_b_port: '바다에서 들어올 때 항로의 왼쪽을 표시합니다 (IALA B: 녹색 원통형).',
  furn_note_lateral_b_starboard:
    '바다에서 들어올 때 항로의 오른쪽을 표시합니다 (IALA B: 입항 시 붉은색은 오른쪽).',
  furn_note_lateral_a_port:
    '바다에서 들어올 때 항로의 좌현 쪽을 표시합니다 (IALA A: 좌현은 붉은색).',
  furn_note_lateral_a_starboard:
    '바다에서 들어올 때 항로의 우현 쪽을 표시합니다 (IALA A: 우현은 녹색).',
  furn_note_safe_water: '사방이 안전수역이며, 보통 육지 초인 또는 항로 중앙 표지입니다.',
  furn_note_isolated_danger: '주변이 항해 가능한 수역인 고립된 위험물 위에 설치되어 있습니다.',
  furn_note_cardinal_north: '방위표지: 북쪽으로 통과하십시오.',
  furn_note_cardinal_east: '방위표지: 동쪽으로 통과하십시오.',
  furn_note_cardinal_south: '방위표지: 남쪽으로 통과하십시오.',
  furn_note_cardinal_west: '방위표지: 서쪽으로 통과하십시오.',
  furn_note_special: '특수표지(황색): 구역 경계, 해저 케이블, 계류, 경기 등.',
  furn_note_preferred_starboard: '분기 표지: 우선 수로는 우현 쪽에 있습니다.',
  furn_note_preferred_port: '분기 표지: 우선 수로는 좌현 쪽에 있습니다.',
  furn_note_mooring: '계류 부표입니다.',
  furn_vessel: '선박',
  furn_depth_quality: '수심 품질',
  furn_length: '길이',
  furn_position_accuracy: '위치 정확도',
  furn_remarks: '비고',
  furn_circumstances: '상황',
  furn_status: '상태',
  furn_note_shom: '프랑스 해양정보국(Shom) 해도 자료. ©Shom, CC BY-SA 4.0.',
  furn_lock: '갑문',
  furn_bridge: '교량',
  furn_overhead_cable: '가공 케이블',
  furn_notice_mark: '고시 표지',
  furn_distance_mark: '거리 표지',
  furn_daymark: '주간 표지',
  furn_channel: '항로',
  furn_vertical_clearance_closed: '수직 유효고 (폐쇄)',
  furn_vertical_clearance_open: '수직 유효고 (개방)',
  furn_datum: '기준면',
  furn_datum_value: '{plane} (VERDAT {code})',
  furn_datum_unknown: 'unknown code (VERDAT {code})',
  furn_note_ienc:
    '내륙 ENC(미 육군 공병대). 유효고는 위에 명시된 기준면 기준 높이이며, 하천 수위가 높으면 실제 여유고는 더 작습니다.',
  furn_note_wreck: '해도에 표시된 침선입니다. 수심은 해도 값이며 검증되지 않았습니다.',
  furn_note_anchorage: '해도에 표시된 묘박 구역입니다.',
  furn_note_tss: '일방통행 항로대입니다. 소형 선박은 직각으로 횡단하고 비켜서 항행합니다.',
  furn_route: '항로',
  furn_fairway: '항행 수로',
  furn_recommended_track: '권장 항로',
  furn_navigation_line: '항해선',
  furn_leading_line: '도등선',
  furn_clearing_line: '안전선',
  furn_transit_line: '통항선',
  furn_traffic: '통항',
  furn_orientation: '방위',
  furn_degrees_value: '{{value}}°',
  furn_note_fairway: '해도에 표시된 수로입니다. 준설되었거나 권장되는 항로를 나타냅니다.',
  furn_note_track: '해도에 표시된 항정선입니다.',
  furn_note_track_fixed_marks: '해도에 표시된 항정선으로, 고정 표지(중시선)를 기준으로 합니다.',
  furn_note_leading_line: '도표를 일직선으로 유지하면 해도에 표시된 선을 따라갈 수 있습니다.',
  furn_note_navigation_line: '해도에 표시된 항해선입니다.',
  furn_poi_marina: '마리나',
  furn_poi_fuel: '연료',
  furn_poi_slipway: '진수 램프',
  furn_poi_ferry_terminal: '여객선 터미널',
  furn_poi_boatyard: '조선소',
  furn_poi_lighthouse: '등대',
  furn_note_slipway: '진수 램프입니다.',
  // Layers sheet — UNTRANSLATED, English placeholders (2026-09-11). Catalog
  // parity is enforced by scripts/check-locale-keys.mjs, so a key cannot be
  // added to en.js alone; these are placeholders awaiting translation, not
  // a claim that the strings are localized.
  layers: 'Layers',
  layers_close: 'Close layers',
  layers_map_type: 'Map type',
  layers_visualizations: 'Visualizations',
  layers_standard_map: 'Standard Map',
  layers_depth_chart: 'Depth Chart',
  layers_moving_tides: 'Moving Tides',
  layers_moving_currents: 'Moving Currents',
  layers_wind_waves: 'Wind & Waves',
  layers_weather_radar: 'Weather Radar',
  layers_coming_soon: 'Coming soon',
  layers_no_currents_here: 'No current stations in view',
  layers_no_radar_here: 'No radar coverage in view',
  // The compass button's accessible name. {{point}} is a 16-point direction
  // (SSW) and {{deg}} the exact bearing — the face rounds to 8 points, this
  // does not. English placeholder in the non-English catalogs, awaiting
  // translation; catalog parity is enforced by scripts/check-locale-keys.mjs.
  follow_my_direction: '내 방향 따라가기',
  compass_faces: 'Map faces {{point}} · {{deg}}°, tap for north-up',
  ww_row_no_data: '{{row}}: 이 지점의 데이터가 없습니다',
  ww_row_no_forecast_after: '{{row}}: {{when}} 이후 예보 없음',
  ww_row_no_forecast: '{{row}}: 이보다 먼 예보는 없습니다',
  ww_unavailable: '날씨 정보를 이용할 수 없습니다',
  explore_show_player: '타임라인 표시',
  explore_hide_player: '타임라인 숨기기',

  // ROUTE PLANNING on /explore (2026-10-23). Describe, never advise; never
  // "safe". route_disclaimer is only the fallback when the service's response
  // carries no disclaimer of its own.
  route_plan: '경로 계획',
  route_leave: '경로 계획 종료',
  route_title: '경로',
  route_prompt_start: '출발할 수면을 탭하세요.',
  route_prompt_start_desktop: '출발할 수면을 클릭한 다음 목적지를 클릭하세요.',
  route_prompt_end: '출발지가 설정되었습니다. 이제 목적지를 탭하세요.',
  route_prompt_end_desktop: '출발지가 설정되었습니다. 이제 목적지를 클릭하세요.',
  route_drag_hint: '핀은 끌어서 옮길 수 있습니다.',
  route_clear: '지우기',
  route_swap: '출발지와 목적지 바꾸기',
  route_share: '링크 복사',
  route_copied: '링크가 복사되었습니다',
  route_start: '출발지',
  route_destination: '목적지',
  route_near: '{{name}} 부근',
  route_loading: '경로를 계산하는 중…',
  route_loading_sub: '보통 1~2초 걸립니다. 일부 해역은 최대 30초가 걸립니다.',
  route_loading_slow: '계속 처리 중…',
  route_loading_slow_sub: '이 해역은 평소보다 오래 걸리고 있습니다.',
  route_summary_time: '{{duration}} ({{speed}} 기준)',
  route_planning_speed: '계획 속력',
  route_shoalest: '경로상 최소 수심',
  route_planning_draft: '계획 흘수',
  route_change: '변경',
  route_draft_title: '계획 흘수',
  route_draft_help:
    '경로 계획에 사용하는 수심이며, 선박의 실제 흘수가 아닙니다. 깊게 하면 경로가 줄고, 얕게 하면 늘어납니다.',
  route_datum: '수심은 해도 기준면(MLLW) 기준이며 조석은 반영하지 않았습니다.',
  route_unassured_note:
    '주황색 구간은 해도와 측량으로 {{draft}} 미만의 수심을 판별할 수 없는 수역을 지납니다.',
  route_row_start: '출발 {{label}}',
  route_row_heading: '침로 {{course}}° ({{point}})',
  route_row_end: '도착 {{label}}',
  route_row_end_sub: '경로 종점',
  route_turn_left: '왼쪽으로 변침하여 {{course}}°',
  route_turn_right: '오른쪽으로 변침하여 {{course}}°',
  route_bear_left: '약간 왼쪽으로 {{course}}°',
  route_bear_right: '약간 오른쪽으로 {{course}}°',
  route_then: '{{first}}, 이어서 {{second}}',
  route_keep_mark: '{{mark}}을(를) {{hand}}에 두고 진행',
  route_leave_channel: '{{mark}}에서 항로를 벗어남',
  route_on_your: '{{hand}} ({{side}})',
  route_hand_left: '왼쪽',
  route_hand_right: '오른쪽',
  route_side_port: '좌현',
  route_side_starboard: '우현',
  route_mark_buoy: '{{color}} 부표 {{num}}',
  route_mark_light: '{{color}} 등표 {{num}}',
  route_mark_daybeacon: '{{color}} 입표 {{num}}',
  route_mark_lighted: '{{mark}} (등화 있음)',
  route_red: '빨간색',
  route_green: '녹색',
  route_follow: '{{name}} 따라 진행',
  route_follow_two: '{{first}}, 이어서 {{second}} 따라 진행',
  route_follow_channel: '{{name}} 항로',
  route_follow_named: '{{name}}',
  route_follow_unnamed: '표지가 있는 항로',
  route_follow_marks: '표지 {{count}}개',
  route_greens_on: '녹색 표지는 {{hand}}',
  route_reds_on: '빨간색 표지는 {{hand}}',
  route_show_marks: '표지 표시',
  route_hide_marks: '표지 숨기기',
  route_why: '여기서 변침하는 이유는?',
  route_turn_reason: '여기서 변침하는 이유: {{reason}}',
  route_lights: '광달 범위 내 등화: {{lights}}',
  route_stretch_unassured: '{{draft}} 미만 수심 판별 불가',
  route_stretch_rocky: '해도상 암초 사이',
  route_stretch_canal: '운하: 갑문 운영, 수문, 교량 여유고는 반영하지 않음',
  route_step_of: '{{total}}단계 중 {{n}}단계',
  route_all_steps: '전체 단계',
  route_prev_step: '이전 단계',
  route_next_step: '다음 단계',
  route_minutes: '{{n}}분',
  route_hours: '{{h}}시간',
  route_hours_minutes: '{{h}}시간 {{m}}분',
  route_err_on_land_origin: '출발지가 해도상 육지에 있습니다',
  route_err_on_land_destination: '목적지가 해도상 육지에 있습니다',
  route_err_on_land_origin_sub:
    '출발지 핀을 수면으로 끌어 옮기세요. 습지, 해변, 부두는 해도에서 육지로 취급됩니다.',
  route_err_on_land_destination_sub:
    '목적지 핀을 수면으로 끌어 옮기세요. 습지, 해변, 부두는 해도에서 육지로 취급됩니다.',
  route_err_no_route: '계획 흘수 {{draft}}에서는 경로가 없습니다',
  route_err_no_route_sub:
    '두 지점 사이 어딘가에서 해도 수심이 {{draft}}보다 얕습니다. 계획 흘수를 줄이면 경로를 찾을 수도 있습니다.',
  route_err_no_snap: '지점 중 하나 근처에 해도상 수역이 없습니다',
  route_err_no_snap_sub: '핀을 트인 수역 가까이로 옮기세요.',
  route_err_outside: '경로 계획은 현재 미국 수역만 지원합니다',
  route_err_outside_sub:
    '경로는 NOAA 해도로 만들기 때문에 두 지점 모두 미국 수역에 있어야 합니다. 다른 연안은 추후 지원합니다.',
  route_err_timeout: '경로 서비스 응답이 너무 오래 걸렸습니다',
  route_err_timeout_sub: '일부 해역은 최대 30초가 걸리며, 이번에는 시간이 초과되었습니다.',
  route_err_unavailable: '지금은 경로 계획을 이용할 수 없습니다',
  route_err_unavailable_sub: '잠시 후 다시 시도하세요.',
  route_err_busy: '경로 요청이 너무 많습니다',
  route_err_busy_sub: '1분 정도 기다린 후 다시 시도하세요.',
  route_try_again: '다시 시도',
  route_disclaimer:
    '항해용이 아닙니다. 이 경로는 해도에 표시된 표지가 있는 항로를 따르며, 안전한 수역임을 주장하는 것이 아닙니다.',
  route_promo_title: '앱의 Go Mode로 이 경로 따라가기',
  route_promo_body:
    'Go Mode는 다음 표지나 변침점까지의 거리, 선박 아래 수심, 가장 가까운 관측소의 조석과 조류와 함께 해도 위에 내 선박을 계속 표시합니다. iPhone 및 Android용 물때 타이드에서 구독으로 이용할 수 있습니다.',
}
